import {
  ApiService,
  type Module,
  type CreateModuleRequest,
  type UpdateModuleRequest,
  type AssignModuleRequest,
  type ModulesPaginatedResponse,
  type ModuleQuery,
} from './api.service'

export class ModuleService extends ApiService {
  /**
   * Get all modules with pagination
   */
  async getModules(query?: ModuleQuery): Promise<ModulesPaginatedResponse> {
    return this.handleResponse(
      this.api.get<ModulesPaginatedResponse>('/modules', { params: query })
    )
  }

  /**
   * Get a module by ID
   */
  async getModuleById(id: string): Promise<Module> {
    return this.handleResponse(this.api.get<Module>(`/modules/${id}`))
  }

  /**
   * Create a new module
   */
  async createModule(moduleData: CreateModuleRequest): Promise<Module> {
    return this.handleResponse(this.api.post<Module>('/modules', moduleData))
  }

  /**
   * Update a module
   */
  async updateModule(id: string, moduleData: UpdateModuleRequest): Promise<Module> {
    return this.handleResponse(this.api.patch<Module>(`/modules/${id}`, moduleData))
  }

  /**
   * Delete a module
   */
  async deleteModule(id: string): Promise<void> {
    return this.handleResponse(this.api.delete<void>(`/modules/${id}`))
  }

  /**
   * Assign module to users
   */
  async assignModule(id: string, assignmentData: AssignModuleRequest): Promise<void> {
    return this.handleResponse(this.api.post<void>(`/modules/${id}/assign`, assignmentData))
  }

  /**
   * Unassign module from user
   */
  async unassignModule(id: string, userId: string): Promise<void> {
    return this.handleResponse(this.api.delete<void>(`/modules/${id}/assign/${userId}`))
  }

  /**
   * Get module assignments
   */
  async getModuleAssignments(id: string): Promise<
    Array<{
      id?: string
      userId?: string
      user?: {
        id?: string
        firstName?: string
        lastName?: string
        email?: string
      }
      assignedAt?: string
    }>
  > {
    return this.handleResponse(
      this.api.get<
        Array<{
          id?: string
          userId?: string
          user?: {
            id?: string
            firstName?: string
            lastName?: string
            email?: string
          }
          assignedAt?: string
        }>
      >(`/modules/${id}/assignments`)
    )
  }
}

// Export singleton instance
export const moduleService = new ModuleService()
